import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import invoiceReportComponent from './invoice-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let invoiceReportModule = angular.module('invoicereport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('laborRevenueByTimePeriod', {
    parent: 'app',
    url: '/admin/reports/invoicereport',
    data: {
      pageHeader: true,
      pageTitle: 'Revenue Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<invoicereport></invoicereport>'
  });

})

.component('invoicereport', invoiceReportComponent);

export default invoiceReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/invoice-report/invoice-report.js